import type { RecipeModel } from '@/server/model/marketplace/recipe/recipeModel';

const extendRecipesByRating = ({
  marketplaceItems,
  recipeDBItems,
}: {
  marketplaceItems: RecipeModel[];
  recipeDBItems: any;
}) => {
  if (!recipeDBItems.length) return [];

  return recipeDBItems.map((recipe: any) => {
    const marketplaceItem = marketplaceItems.find((item) => item.recipeDBId === recipe.Id);

    if (!marketplaceItem) return recipe;

    return {
      ...recipe,
      Rating: marketplaceItem.rating.averageRatingScore,
    };
  });
};

const normalizeRating = ({
  numberOfVotes,
  averageRatingScore,
}: {
  numberOfVotes?: number;
  averageRatingScore?: number;
}) => {
  if (Number(averageRatingScore) > 5) {
    return { numberOfVotes: 0, averageRatingScore: 0 };
  }
  return {
    numberOfVotes: numberOfVotes ? Number(numberOfVotes) : 0,
    averageRatingScore: averageRatingScore ? Number(averageRatingScore) : 0,
  };
};

export const RatingService = {
  extendRecipesByRating,
  normalizeRating,
};
